import { configureStore } from '@reduxjs/toolkit'

import weatherReducer from './features/weather/weatherSlice'
import environmentReducer from './features/environment/environmentSlice'
import cultivationReportReducer from './features/cultivation_report/cultivationReportSlice'
import cultivationRecordsReducer from './features/cultivation_report/cultivationRecordsSlice'
import harvestReportReducer from './features/harvest_report/harvestReportSlice'
import harvestUpdateReducer from './features/harvest_report/harvestUpdateSlice'
import harvestAllReportReducer from './features/harvest_report/harvestAllReportSlice'
import cultivationModelReducer from './features/cultivation_models/cultivationModelSlice'
import cultivationUpdateReducer from './features/cultivation_models/cultivationUpdateSlice'
import cultivationDeleteReducer from './features/cultivation_models/cultivationDeleteSlice'
import irrigationReportReducer from './features/irrigation_report/irrigationSlice'
import irrigationAllReducer from './features/irrigation_report/irrigationAllSlice'
import plantingReportReducer from './features/planting_calender/plantingReportSlice'
import sensorsReducer from './features/environment/sensorsSlice'
import profileReducer from './features/profile/profileSlice'

export default configureStore({
  reducer: {
    weather: weatherReducer,
    environment: environmentReducer,
    profile: profileReducer,
    cultivation_report: cultivationReportReducer,
    cultivation_records: cultivationRecordsReducer,
    harvest_report: harvestReportReducer,
    harvest_update: harvestUpdateReducer,
    harvest_all_report: harvestAllReportReducer,
    cultivation_models: cultivationModelReducer,
    cultivation_update: cultivationUpdateReducer,
    cultivation_delete: cultivationDeleteReducer,
    irrigation_report: irrigationReportReducer,
    irrigation_all: irrigationAllReducer,
    planting_report: plantingReportReducer,
    sensors: sensorsReducer,
  },
})
